import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type ClockOutMutationVariables = Types.Exact<{ [key: string]: never }>

export type ClockOutMutation = {
   __typename?: 'Mutation'
   clockOut:
      | { __typename?: 'ClockInNotAttempted'; message?: string | null }
      | { __typename?: 'ClockOutResult'; userId: string }
      | {
           __typename?: 'FeatureNotEnabled'
           message?: string | null
           feature: Types.CrmAccountFeatureEnum
        }
}

export const ClockOutDocument = gql`
   mutation ClockOut {
      clockOut {
         ... on ClockOutResult {
            userId
         }
         ... on FeatureNotEnabled {
            message
            feature
         }
         ... on ClockInNotAttempted {
            message
         }
      }
   }
`
export type ClockOutMutationFn = Apollo.MutationFunction<
   ClockOutMutation,
   ClockOutMutationVariables
>
export type ClockOutMutationResult = Apollo.MutationResult<ClockOutMutation>
export type ClockOutMutationOptions = Apollo.BaseMutationOptions<
   ClockOutMutation,
   ClockOutMutationVariables
>
